import Carousel from "@/components/slider/Carousel";
import VideoCard from "../items/VideoCard";

function CarouselVideo({
  title,
  showMoreText,
  showMoreLink,
  data,
  videoHeight,
  isLoading = false,
  container,
}) {
  return (
    <Carousel
      title={title}
      showMoreText={showMoreText}
      showMoreLink={showMoreLink}
      container={container}
    >
      {!isLoading
        ? data.map((item, index) => (
            <VideoCard
              videoHeight={videoHeight}
              data={item}
              key={`video-${item.uuid}`}
              container={container}
            />
          ))
        : data.map((item, index) => <div key={`video-${item.uuid}`}></div>)}
    </Carousel>
  );
}
export default CarouselVideo;
